import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import Pincode from "./PincodeDetail";

const TrackShipment = () => {
  const [trackingNo, setTrackingNo] = useState("");
  const [pincode_No, setpincode_No] = useState("");
  const [error, setError] = useState(null); // State for tracking errors

  const navigate = useNavigate();

  const handleTrackClick = () => {
    if (trackingNo.trim() === "") {
      setError("Please enter a valid tracking number / PIN Code");
    } else if (trackingNo.length < 6 || pincode_No.length < 6) {
      setError("Please enter at least six digits number");
    } else if (
      pincode_No.length === 6 &&
      /^[0-9a-zA-Z-]{6}$/.test(pincode_No)
    ) {
      setError(null);
      navigate(`/pincode_details/${pincode_No}`);
    } else if (
      trackingNo.length > 18 &&
      /^[0-9a-zA-Z-,]{8,}$/.test(trackingNo)
    ) {
      setError(null);
      navigate(`/multiple_tracking_details/${trackingNo}`);
    } else if (
      trackingNo.length > 8 &&
      /^[0-9a-zA-Z-,]{8,}$/.test(trackingNo)
    ) {
      setError(null);
      navigate(`/tracking_details/${trackingNo}`);
    } else {
      setError("Invalid Tracking or Pincode number");
    }

    setTrackingNo("");
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent the default form submission behavior (refresh)
      handleTrackClick(); // Call the same function as the track button click
    }
  };

  // const handleInputChange = (e) => {
  //   setTrackingNo(e.target.value); // Update trackingNo state
  //   setpincode_No(e.target.value);
  // };
  const handleInputChange = (e) => {
    setTrackingNo(e.target.value.trim()); // Update trackingNo state
    setpincode_No(e.target.value.trim());
  };

  return (
    <>
      <section className="my-2">
        <div className="track-shipments">
          <Form>
            <div className="tracking_shipment">
              <input
                type="text"
                placeholder="Enter Tracking Number / PIN Code"
                value={trackingNo}
                className="form-control "
                onChange={handleInputChange}
                // onChange={(e) => setTrackingNo(e.target.value)}
                onKeyPress={handleKeyPress} // Call handleKeyPress on key press
                required
              />
              <button
                type="button"
                className="button-34"
                onClick={handleTrackClick}
              >
                Track
              </button>
            </div>
          </Form>
          <small>Track multiple shipments with commas(,)</small>
          <br />
          {error && <p className="error-message">{error}</p>}{" "}
          {/* Show error message */}
        </div>
      </section>
    </>
  );
};

export default TrackShipment;
